export interface DailyPuzzle {
  id: string;
  date: string;
  imageUrl: string;
  difficulty: number; // Grid size
  title?: string;
}

// Daily puzzles for October and November 2025
export const dailyPuzzles: DailyPuzzle[] = [
  // October 2025
  {
    id: 'daily_2025-10-01',
    date: '2025-10-01',
    imageUrl: 'https://picsum.photos/seed/oct1/600/800',
    difficulty: 8,
    title: 'October 1'
  },
  {
    id: 'daily_2025-10-02',
    date: '2025-10-02',
    imageUrl: 'https://picsum.photos/seed/oct2/600/800',
    difficulty: 8,
    title: 'October 2'
  },
  {
    id: 'daily_2025-10-03',
    date: '2025-10-03',
    imageUrl: 'https://picsum.photos/seed/oct3/600/800',
    difficulty: 8,
    title: 'October 3'
  },
  {
    id: 'daily_2025-10-04',
    date: '2025-10-04',
    imageUrl: 'https://picsum.photos/seed/oct4/600/800',
    difficulty: 8,
    title: 'October 4'
  },
  {
    id: 'daily_2025-10-05',
    date: '2025-10-05',
    imageUrl: 'https://picsum.photos/seed/oct5/600/800',
    difficulty: 8,
    title: 'October 5'
  },
  {
    id: 'daily_2025-10-06',
    date: '2025-10-06',
    imageUrl: 'https://picsum.photos/seed/oct6/600/800',
    difficulty: 8,
    title: 'October 6'
  },
  {
    id: 'daily_2025-10-07',
    date: '2025-10-07',
    imageUrl: 'https://picsum.photos/seed/oct7/600/800',
    difficulty: 8,
    title: 'October 7'
  },
  {
    id: 'daily_2025-10-08',
    date: '2025-10-08',
    imageUrl: 'https://picsum.photos/seed/oct8/600/800',
    difficulty: 8,
    title: 'October 8'
  },
  {
    id: 'daily_2025-10-09',
    date: '2025-10-09',
    imageUrl: 'https://picsum.photos/seed/oct9/600/800',
    difficulty: 8,
    title: 'October 9'
  },
  {
    id: 'daily_2025-10-10',
    date: '2025-10-10',
    imageUrl: 'https://picsum.photos/seed/oct10/600/800',
    difficulty: 8,
    title: 'October 10'
  },
  {
    id: 'daily_2025-10-11',
    date: '2025-10-11',
    imageUrl: 'https://picsum.photos/seed/oct11/600/800',
    difficulty: 8,
    title: 'October 11'
  },
  {
    id: 'daily_2025-10-12',
    date: '2025-10-12',
    imageUrl: 'https://picsum.photos/seed/oct12/600/800',
    difficulty: 8,
    title: 'October 12'
  },
  {
    id: 'daily_2025-10-13',
    date: '2025-10-13',
    imageUrl: 'https://picsum.photos/seed/oct13/600/800',
    difficulty: 8,
    title: 'October 13'
  },
  {
    id: 'daily_2025-10-14',
    date: '2025-10-14',
    imageUrl: 'https://picsum.photos/seed/oct14/600/800',
    difficulty: 8,
    title: 'October 14'
  },
  {
    id: 'daily_2025-10-15',
    date: '2025-10-15',
    imageUrl: 'https://picsum.photos/seed/oct15/600/800',
    difficulty: 8,
    title: 'October 15'
  },
  {
    id: 'daily_2025-10-16',
    date: '2025-10-16',
    imageUrl: 'https://picsum.photos/seed/oct16/600/800',
    difficulty: 8,
    title: 'October 16'
  },
  {
    id: 'daily_2025-10-17',
    date: '2025-10-17',
    imageUrl: 'https://picsum.photos/seed/oct17/600/800',
    difficulty: 8,
    title: 'October 17'
  },
  {
    id: 'daily_2025-10-18',
    date: '2025-10-18',
    imageUrl: 'https://picsum.photos/seed/oct18/600/800',
    difficulty: 8,
    title: 'October 18'
  },
  {
    id: 'daily_2025-10-19',
    date: '2025-10-19',
    imageUrl: 'https://picsum.photos/seed/oct19/600/800',
    difficulty: 8,
    title: 'October 19'
  },
  {
    id: 'daily_2025-10-20',
    date: '2025-10-20',
    imageUrl: 'https://picsum.photos/seed/oct20/600/800',
    difficulty: 8,
    title: 'October 20'
  },
  {
    id: 'daily_2025-10-21',
    date: '2025-10-21',
    imageUrl: 'https://picsum.photos/seed/oct21/600/800',
    difficulty: 8,
    title: 'October 21'
  },
  {
    id: 'daily_2025-10-22',
    date: '2025-10-22',
    imageUrl: 'https://picsum.photos/seed/oct22/600/800',
    difficulty: 8,
    title: 'October 22'
  },
  {
    id: 'daily_2025-10-23',
    date: '2025-10-23',
    imageUrl: 'https://picsum.photos/seed/oct23/600/800',
    difficulty: 8,
    title: 'October 23'
  },
  {
    id: 'daily_2025-10-24',
    date: '2025-10-24',
    imageUrl: 'https://picsum.photos/seed/oct24/600/800',
    difficulty: 8,
    title: 'October 24'
  },
  {
    id: 'daily_2025-10-25',
    date: '2025-10-25',
    imageUrl: 'https://picsum.photos/seed/oct25/600/800',
    difficulty: 8,
    title: 'October 25'
  },
  {
    id: 'daily_2025-10-26',
    date: '2025-10-26',
    imageUrl: 'https://picsum.photos/seed/oct26/600/800',
    difficulty: 8,
    title: 'October 26'
  },
  {
    id: 'daily_2025-10-27',
    date: '2025-10-27',
    imageUrl: 'https://picsum.photos/seed/oct27/600/800',
    difficulty: 8,
    title: 'October 27'
  },
  {
    id: 'daily_2025-10-28',
    date: '2025-10-28',
    imageUrl: 'https://picsum.photos/seed/oct28/600/800',
    difficulty: 8,
    title: 'October 28'
  },
  {
    id: 'daily_2025-10-29',
    date: '2025-10-29',
    imageUrl: 'https://picsum.photos/seed/oct29/600/800',
    difficulty: 8,
    title: 'October 29'
  },
  {
    id: 'daily_2025-10-30',
    date: '2025-10-30',
    imageUrl: 'https://picsum.photos/seed/oct30/600/800',
    difficulty: 8,
    title: 'October 30'
  },
  {
    id: 'daily_2025-10-31',
    date: '2025-10-31',
    imageUrl: 'https://picsum.photos/seed/oct31/600/800',
    difficulty: 8,
    title: 'October 31'
  },
  // November 2025
  {
    id: 'daily_2025-11-01',
    date: '2025-11-01',
    imageUrl: 'https://picsum.photos/seed/daily1/600/800',
    difficulty: 8,
    title: 'November 1'
  },
  {
    id: 'daily_2025-11-02',
    date: '2025-11-02',
    imageUrl: 'https://picsum.photos/seed/daily2/600/800',
    difficulty: 8,
    title: 'November 2'
  },
  {
    id: 'daily_2025-11-03',
    date: '2025-11-03',
    imageUrl: 'https://picsum.photos/seed/daily3/600/800',
    difficulty: 8,
    title: 'November 3'
  },
  {
    id: 'daily_2025-11-04',
    date: '2025-11-04',
    imageUrl: 'https://picsum.photos/seed/daily4/600/800',
    difficulty: 8,
    title: 'November 4'
  },
  {
    id: 'daily_2025-11-05',
    date: '2025-11-05',
    imageUrl: 'https://picsum.photos/seed/daily5/600/800',
    difficulty: 8,
    title: 'November 5'
  },
  {
    id: 'daily_2025-11-06',
    date: '2025-11-06',
    imageUrl: 'https://picsum.photos/seed/daily6/600/800',
    difficulty: 8,
    title: 'November 6'
  },
  {
    id: 'daily_2025-11-07',
    date: '2025-11-07',
    imageUrl: 'https://picsum.photos/seed/daily7/600/800',
    difficulty: 8,
    title: 'November 7'
  },
  {
    id: 'daily_2025-11-08',
    date: '2025-11-08',
    imageUrl: 'https://picsum.photos/seed/daily8/600/800',
    difficulty: 8,
    title: 'November 8'
  },
  {
    id: 'daily_2025-11-09',
    date: '2025-11-09',
    imageUrl: 'https://picsum.photos/seed/daily9/600/800',
    difficulty: 8,
    title: 'November 9'
  },
  {
    id: 'daily_2025-11-10',
    date: '2025-11-10',
    imageUrl: 'https://picsum.photos/seed/daily10/600/800',
    difficulty: 8,
    title: 'November 10'
  },
  {
    id: 'daily_2025-11-11',
    date: '2025-11-11',
    imageUrl: 'https://picsum.photos/seed/daily11/600/800',
    difficulty: 8,
    title: 'November 11'
  },
  {
    id: 'daily_2025-11-12',
    date: '2025-11-12',
    imageUrl: 'https://picsum.photos/seed/daily12/600/800',
    difficulty: 8,
    title: 'November 12'
  },
  {
    id: 'daily_2025-11-13',
    date: '2025-11-13',
    imageUrl: 'https://picsum.photos/seed/daily13/600/800',
    difficulty: 8,
    title: 'November 13'
  },
  {
    id: 'daily_2025-11-14',
    date: '2025-11-14',
    imageUrl: 'https://picsum.photos/seed/daily14/600/800',
    difficulty: 8,
    title: 'November 14'
  },
  {
    id: 'daily_2025-11-15',
    date: '2025-11-15',
    imageUrl: 'https://picsum.photos/seed/daily15/600/800',
    difficulty: 8,
    title: 'November 15'
  },
  {
    id: 'daily_2025-11-16',
    date: '2025-11-16',
    imageUrl: 'https://picsum.photos/seed/daily16/600/800',
    difficulty: 8,
    title: 'November 16'
  },
  {
    id: 'daily_2025-11-17',
    date: '2025-11-17',
    imageUrl: 'https://picsum.photos/seed/daily17/600/800',
    difficulty: 8,
    title: 'November 17'
  },
  {
    id: 'daily_2025-11-18',
    date: '2025-11-18',
    imageUrl: 'https://picsum.photos/seed/daily18/600/800',
    difficulty: 8,
    title: 'November 18'
  },
  {
    id: 'daily_2025-11-19',
    date: '2025-11-19',
    imageUrl: 'https://picsum.photos/seed/daily19/600/800',
    difficulty: 8,
    title: 'November 19'
  },
  {
    id: 'daily_2025-11-20',
    date: '2025-11-20',
    imageUrl: 'https://picsum.photos/seed/daily20/600/800',
    difficulty: 8,
    title: 'November 20'
  },
  {
    id: 'daily_2025-11-21',
    date: '2025-11-21',
    imageUrl: 'https://picsum.photos/seed/daily21/600/800',
    difficulty: 8,
    title: 'November 21'
  },
  {
    id: 'daily_2025-11-22',
    date: '2025-11-22',
    imageUrl: 'https://picsum.photos/seed/daily22/600/800',
    difficulty: 8,
    title: 'November 22'
  },
  {
    id: 'daily_2025-11-23',
    date: '2025-11-23',
    imageUrl: 'https://picsum.photos/seed/daily23/600/800',
    difficulty: 8,
    title: 'November 23'
  },
  {
    id: 'daily_2025-11-24',
    date: '2025-11-24',
    imageUrl: 'https://picsum.photos/seed/daily24/600/800',
    difficulty: 8,
    title: 'November 24'
  },
  {
    id: 'daily_2025-11-25',
    date: '2025-11-25',
    imageUrl: 'https://picsum.photos/seed/daily25/600/800',
    difficulty: 8,
    title: 'November 25'
  },
  {
    id: 'daily_2025-11-26',
    date: '2025-11-26',
    imageUrl: 'https://picsum.photos/seed/daily26/600/800',
    difficulty: 8,
    title: 'November 26'
  },
  {
    id: 'daily_2025-11-27',
    date: '2025-11-27',
    imageUrl: 'https://picsum.photos/seed/daily27/600/800',
    difficulty: 8,
    title: 'November 27'
  },
  {
    id: 'daily_2025-11-28',
    date: '2025-11-28',
    imageUrl: 'https://picsum.photos/seed/daily28/600/800',
    difficulty: 8,
    title: 'November 28'
  },
  {
    id: 'daily_2025-11-29',
    date: '2025-11-29',
    imageUrl: 'https://picsum.photos/seed/daily29/600/800',
    difficulty: 8,
    title: 'November 29'
  },
  {
    id: 'daily_2025-11-30',
    date: '2025-11-30',
    imageUrl: 'https://picsum.photos/seed/daily30/600/800',
    difficulty: 8,
    title: 'November 30'
  },
  // December 2025
  {
    id: 'daily_2025-12-01',
    date: '2025-12-01',
    imageUrl: 'https://picsum.photos/seed/dec1/600/800',
    difficulty: 8,
    title: 'December 1'
  },
  {
    id: 'daily_2025-12-02',
    date: '2025-12-02',
    imageUrl: 'https://picsum.photos/seed/dec2/600/800',
    difficulty: 8,
    title: 'December 2'
  },
  {
    id: 'daily_2025-12-03',
    date: '2025-12-03',
    imageUrl: 'https://picsum.photos/seed/dec3/600/800',
    difficulty: 8,
    title: 'December 3'
  },
  {
    id: 'daily_2025-12-04',
    date: '2025-12-04',
    imageUrl: 'https://picsum.photos/seed/dec4/600/800',
    difficulty: 8,
    title: 'December 4'
  },
  {
    id: 'daily_2025-12-05',
    date: '2025-12-05',
    imageUrl: 'https://picsum.photos/seed/dec5/600/800',
    difficulty: 8,
    title: 'December 5'
  },
  {
    id: 'daily_2025-12-06',
    date: '2025-12-06',
    imageUrl: 'https://picsum.photos/seed/dec6/600/800',
    difficulty: 8,
    title: 'December 6'
  },
  {
    id: 'daily_2025-12-07',
    date: '2025-12-07',
    imageUrl: 'https://picsum.photos/seed/dec7/600/800',
    difficulty: 8,
    title: 'December 7'
  },
  {
    id: 'daily_2025-12-08',
    date: '2025-12-08',
    imageUrl: 'https://picsum.photos/seed/dec8/600/800',
    difficulty: 8,
    title: 'December 8'
  },
  {
    id: 'daily_2025-12-09',
    date: '2025-12-09',
    imageUrl: 'https://picsum.photos/seed/dec9/600/800',
    difficulty: 8,
    title: 'December 9'
  },
  {
    id: 'daily_2025-12-10',
    date: '2025-12-10',
    imageUrl: 'https://picsum.photos/seed/dec10/600/800',
    difficulty: 8,
    title: 'December 10'
  },
  {
    id: 'daily_2025-12-11',
    date: '2025-12-11',
    imageUrl: 'https://picsum.photos/seed/dec11/600/800',
    difficulty: 8,
    title: 'December 11'
  },
  {
    id: 'daily_2025-12-12',
    date: '2025-12-12',
    imageUrl: 'https://picsum.photos/seed/dec12/600/800',
    difficulty: 8,
    title: 'December 12'
  },
  {
    id: 'daily_2025-12-13',
    date: '2025-12-13',
    imageUrl: 'https://picsum.photos/seed/dec13/600/800',
    difficulty: 8,
    title: 'December 13'
  },
  {
    id: 'daily_2025-12-14',
    date: '2025-12-14',
    imageUrl: 'https://picsum.photos/seed/dec14/600/800',
    difficulty: 8,
    title: 'December 14'
  },
  {
    id: 'daily_2025-12-15',
    date: '2025-12-15',
    imageUrl: 'https://picsum.photos/seed/dec15/600/800',
    difficulty: 8,
    title: 'December 15'
  },
  {
    id: 'daily_2025-12-16',
    date: '2025-12-16',
    imageUrl: 'https://picsum.photos/seed/dec16/600/800',
    difficulty: 8,
    title: 'December 16'
  },
  {
    id: 'daily_2025-12-17',
    date: '2025-12-17',
    imageUrl: 'https://picsum.photos/seed/dec17/600/800',
    difficulty: 8,
    title: 'December 17'
  },
  {
    id: 'daily_2025-12-18',
    date: '2025-12-18',
    imageUrl: 'https://picsum.photos/seed/dec18/600/800',
    difficulty: 8,
    title: 'December 18'
  },
  {
    id: 'daily_2025-12-19',
    date: '2025-12-19',
    imageUrl: 'https://picsum.photos/seed/dec19/600/800',
    difficulty: 8,
    title: 'December 19'
  },
  {
    id: 'daily_2025-12-20',
    date: '2025-12-20',
    imageUrl: 'https://picsum.photos/seed/dec20/600/800',
    difficulty: 8,
    title: 'December 20'
  },
  {
    id: 'daily_2025-12-21',
    date: '2025-12-21',
    imageUrl: 'https://picsum.photos/seed/dec21/600/800',
    difficulty: 8,
    title: 'December 21'
  },
  {
    id: 'daily_2025-12-22',
    date: '2025-12-22',
    imageUrl: 'https://picsum.photos/seed/dec22/600/800',
    difficulty: 8,
    title: 'December 22'
  },
  {
    id: 'daily_2025-12-23',
    date: '2025-12-23',
    imageUrl: 'https://picsum.photos/seed/dec23/600/800',
    difficulty: 8,
    title: 'December 23'
  },
  {
    id: 'daily_2025-12-24',
    date: '2025-12-24',
    imageUrl: 'https://picsum.photos/seed/dec24/600/800',
    difficulty: 8,
    title: 'December 24'
  },
  {
    id: 'daily_2025-12-25',
    date: '2025-12-25',
    imageUrl: 'https://picsum.photos/seed/dec25/600/800',
    difficulty: 8,
    title: 'December 25'
  },
  {
    id: 'daily_2025-12-26',
    date: '2025-12-26',
    imageUrl: 'https://picsum.photos/seed/dec26/600/800',
    difficulty: 8,
    title: 'December 26'
  },
  {
    id: 'daily_2025-12-27',
    date: '2025-12-27',
    imageUrl: 'https://picsum.photos/seed/dec27/600/800',
    difficulty: 8,
    title: 'December 27'
  },
  {
    id: 'daily_2025-12-28',
    date: '2025-12-28',
    imageUrl: 'https://picsum.photos/seed/dec28/600/800',
    difficulty: 8,
    title: 'December 28'
  },
  {
    id: 'daily_2025-12-29',
    date: '2025-12-29',
    imageUrl: 'https://picsum.photos/seed/dec29/600/800',
    difficulty: 8,
    title: 'December 29'
  },
  {
    id: 'daily_2025-12-30',
    date: '2025-12-30',
    imageUrl: 'https://picsum.photos/seed/dec30/600/800',
    difficulty: 8,
    title: 'December 30'
  },
  {
    id: 'daily_2025-12-31',
    date: '2025-12-31',
    imageUrl: 'https://picsum.photos/seed/dec31/600/800',
    difficulty: 8,
    title: 'December 31'
  }
];

// Cache for fetched puzzles to avoid repeated API calls
const puzzleCache = new Map<string, DailyPuzzle>();

// Helper function to check if a puzzle exists locally (for calendar rendering)
export function hasPuzzleForDate(dateString: string): boolean {
  // Check cache first
  if (puzzleCache.has(dateString)) {
    return true;
  }
  // Check local puzzles
  return dailyPuzzles.some(puzzle => puzzle.date === dateString);
}

// Helper function to get local puzzle data synchronously (for calendar rendering)
export function getLocalPuzzleByDate(dateString: string): DailyPuzzle | undefined {
  // Check cache first
  if (puzzleCache.has(dateString)) {
    return puzzleCache.get(dateString);
  }
  // Check local puzzles
  return dailyPuzzles.find(puzzle => puzzle.date === dateString);
}

export async function getDailyPuzzleByDate(dateString: string): Promise<DailyPuzzle | undefined> {
  // Check cache first
  if (puzzleCache.has(dateString)) {
    return puzzleCache.get(dateString);
  }

  try {
    const response = await fetch(`https://joinsaw.com/Rest/daily/${dateString}`);

    if (!response.ok) {
      if (response.status === 404) {
        console.log('No puzzle available from API for date:', dateString, '- falling back to local puzzles');
        // Fall back to local puzzles instead of returning undefined
        return dailyPuzzles.find(puzzle => puzzle.date === dateString);
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    // Extract puzzle from result wrapper
    const puzzle: DailyPuzzle = data.result || data;

    // Validate that the puzzle has required fields
    if (!puzzle.imageUrl) {
      console.warn('API returned puzzle without imageUrl, falling back to local puzzles');
      return dailyPuzzles.find(p => p.date === dateString);
    }

    // No need to normalize - API and local both use hyphens now

    // Cache the puzzle
    puzzleCache.set(dateString, puzzle);

    return puzzle;
  } catch (error) {
    console.error('Error fetching daily puzzle:', error);

    // Fallback to local puzzles if API fails
    return dailyPuzzles.find(puzzle => puzzle.date === dateString);
  }
}

export function getDailyPuzzleById(id: string): DailyPuzzle | undefined {
  // Check cache first
  for (const puzzle of puzzleCache.values()) {
    if (puzzle.id === id) {
      return puzzle;
    }
  }

  // Fallback to local puzzles
  return dailyPuzzles.find(puzzle => puzzle.id === id);
}

export async function getTodaysPuzzle(): Promise<DailyPuzzle | undefined> {
  const today = new Date();
  const dateString = today.toISOString().split('T')[0];
  return await getDailyPuzzleByDate(dateString);
}
